const numberFormatCache: Map<string, Intl.NumberFormat> = new Map<string, Intl.NumberFormat>();

/**
 * Formats an average rating for display in the active storefront locale with exactly one fractional
 * digit (e.g. de-AT `4.8` → "4,8", `5` → "5,0"). Apollo already rounds the value to one decimal;
 * this only applies the locale-aware number format for the visible text and matching aria-labels.
 */
const formatRatingValue = (rating: number, locale: string): string => {
  let numberFormat: Intl.NumberFormat | undefined = numberFormatCache.get(locale);

  if (numberFormat === undefined) {
    numberFormat = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    });

    numberFormatCache.set(locale, numberFormat);
  }

  return numberFormat.format(rating);
};

export default formatRatingValue;
